import { render, staticRenderFns } from "./promotion_operate.vue?vue&type=template&id=93600cc8&scoped=true&"
import script from "./promotion_operate.vue?vue&type=script&lang=ts&"
export * from "./promotion_operate.vue?vue&type=script&lang=ts&"
import style0 from "./promotion_operate.vue?vue&type=style&index=0&id=93600cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93600cc8",
  null
  
)

export default component.exports